module.exports = __webpack_public_path__ + "img/fe045c6.jpg";